/* línkè · 聊天头像（2026-07-29 铃点单：像 QQ 那样自己传图）
   传了图 → 圆形照片；没传 → 一直以来的 ☾ / ✦ 字符（原样，连动画都不变）。
   所以这个组件只是在原来的 <span> 外面加了一层「有没有图」的分叉。 */
import { useEffect, useState } from 'react';
import { AVATAR_FALLBACK, getAvatar, subscribeAvatars } from '../lib/avatar.js';

export default function Avatar({ who, className = '', title }) {
  const [src, setSrc] = useState(() => getAvatar(who));
  useEffect(() => subscribeAvatars((a) => setSrc(a[who] || null)), [who]);

  if (src) {
    return (
      <img
        className={`${className} ch-avatar-img`}
        src={src}
        alt=""
        aria-hidden="true"
        title={title}
        draggable="false"
      />
    );
  }
  return (
    <span className={className} aria-hidden="true" title={title}>
      {AVATAR_FALLBACK[who] || '✦'}
    </span>
  );
}
